import actions from "./actions"

const initialState = {
    driver: {},
    drivers: []
};

export default function driverReducers(state = initialState, action: {payload: any, type: string}):any{
    switch (action.type){
        case actions.SET_DRIVER:
            return {...state, driver: action.payload};
        case actions.SET_DRIVERS:
            return {...state, drivers: action.payload};
        case actions.SET_INITIAL:
            return {...state, driver: {}};
        default:
            return state
    }
}